import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {mcpLimitLogStateSelector} from './mcp-limit-log-state.slice';

import type {McpLimitLogCriteria} from '../typedef';
import type {McpLimitLogSortField} from './mcp-limit-log-state.slice';
import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountMcpLimitLogHits} from 'src/openapi/admin/models/AccountMcpLimitLogHits';
import type {UserMcpLimitLogHits} from 'src/openapi/admin/models/UserMcpLimitLogHits';

type McpLimitLogEvents = (UserMcpLimitLogHits | AccountMcpLimitLogHits)[];

export const mcpLimitLogDataSlice = getCachedTableDataSlice<
    McpLimitLogEvents,
    undefined,
    McpLimitLogSortField,
    McpLimitLogCriteria
>('mcpLimitLog');

export const mcpLimitLogDataActions = mcpLimitLogDataSlice.actions;
const mcpLimitLogCacheSelector: CachedTableCacheSelector<McpLimitLogEvents>
    = state => state.accountPage.tabs.licenseAndFeatures.mcpLimitLog.events.cache;
export const mcpLimitLogDataSelector: CachedTableDataSelector<McpLimitLogEvents>
    = state => state.accountPage.tabs.licenseAndFeatures.mcpLimitLog.events;
export const mcpLimitLogResultSelector = getCachedTableResultSelector(
    mcpLimitLogCacheSelector,
    mcpLimitLogStateSelector,
);
